// library
import { FC } from "react";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
// material
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Grid,
} from '@mui/material';
// type
import { Sightseeing } from "../types/sightseeing";
// common
import { Divider } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': { padding: theme.spacing(2), },
    '& .MuiDialogActions-root': { padding: theme.spacing(1), },
}));

const sightseeingInfoDialog: FC<any> = ( props: { config: any, isOpenDialog: boolean, setIsOpenDialog: any, detailSightseeing: Sightseeing }) => {
    const { config, isOpenDialog, setIsOpenDialog, detailSightseeing } = props;
    
    const image = `${config.localImageUrl}${detailSightseeing?.image}.jpg`;

    const Img = styled('img')({
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    });

    // ダイアログの閉じる押下時
    const handleClose = () => {
        // 閉じる
        setIsOpenDialog(false);
    }

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={isOpenDialog}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {detailSightseeing?.title}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
            <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <div className="event-dialog-image">
                    <Img 
                        src={image}
                        alt={detailSightseeing?.title}
                    />
                </div>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {detailSightseeing?.description}
                </Typography>
                {
                    detailSightseeing?.url &&
                        <Typography gutterBottom>
                            <img
                                className="pictogram"
                                src="./icons/icon-link.svg"
                                height={20}
                            />
                            <a href={detailSightseeing?.url} target="_blank">{detailSightseeing?.title}</a><br/>
                        </Typography>
                }
            </DialogContent>
            <Button autoFocus onClick={handleClose}>
                閉じる
            </Button>
        </BootstrapDialog>
    );
}

export default sightseeingInfoDialog;